import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Negotiation from "./sections/Negotiation";
import Advocacy from "./sections/Advocacy";
import Expertise from "./sections/Expertise";
import Testimonials from "./sections/Testimonials";
import Advocate from "./sections/Advocate";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Negotiation />
      <Advocacy />
      <Expertise />
      <Testimonials />
      <Advocate />
      <Footer />
    </div>;
}